import React from 'react';

const Icon = (props) => (
    <span className="c-icon" data-icon={props.icon}></span>
);

export default Icon;